<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="公司名称"
        v-model.trim="companyName"
        class="handle-input mr10"
      ></el-input>
      <el-select size="small" v-model="time" @change="search" class="mr10">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        size="small"
        v-model="reportType"
        @change="search"
        class="mr10"
      >
        <el-option
          v-for="item in type_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select size="small" v-model="scaleType" @change="search" class="mr10">
        <el-option
          v-for="item in company_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="220px" header-align="center" label="用户名称">
        <template #default="scope">
          <ul>
            <li>订单号：{{ scope.row.orderNo }}</li>
            <li>{{ scope.row.name }}</li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        align="center"
        label="报告类型"
        :formatter="formatType"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="realname"
        label="联系人"
      ></el-table-column>
      <el-table-column
        width="130px"
        prop="username"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column min-width="170" align="center" label="申请时间">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.applyTime, "yyyy-MM-dd hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column
        prop="scaleType"
        align="center"
        label="企业规模"
        :formatter="formaScale"
      >
      </el-table-column>

      <el-table-column min-width="100px" align="center" label="支付金额">
        <template #default="scope">{{ scope.row.price }}元 </template>
      </el-table-column>
      <el-table-column min-width="120px" align="center" label="支付方式">
        <template #default="scope">
          <ul>
            <li>公司转账</li>
            <li>
              <el-button type="text" @click="payment(scope.row)"
                >查看转账信息</el-button
              >
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column width="170px" align="center" label="出具报告期限">
        <template #default="scope">
          <ul
            :class="{
              overdue: scope.row.time === 1,
              rational: scope.row.time === 0,
            }"
          >
            <li>
              开始时间：{{
                $utils.formatDate(scope.row.startTime, "yyyy-MM-dd")
              }}
            </li>
            <!-- <li>至</li> -->
            <li>
              截止时间：{{ $utils.formatDate(scope.row.endTime, "yyyy-MM-dd") }}
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template #default="scope">
          <el-button type="primary" size="mini" @click="archives(scope.row)"
            >查看档案</el-button
          >
          <el-button
            type="success"
            size="mini"
            @click="
              itemData = scope.row;
              report_dialog = true;
            "
            >提交报告</el-button
          >
        </template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="操作人">
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
    <!-- 查看档案 -->
    <el-dialog v-model="archives_dialog" width="900px" destroy-on-close>
      <div class="preview-dialog">
        <company></company>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" size="mini" @click="archives_dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 付款信息 -->
    <el-dialog
      v-model="payment_dialog"
      width="900px"
      title="付款信息"
      destroy-on-close
    >
      <div class="payment_dialog-body">
        <el-form size="mini" label-position="right" label-width="90px">
          <el-form-item label="付款账号：">{{
            itemData.payAccount
          }}</el-form-item>
          <el-form-item label="付款银行：">{{
            itemData.paymentBank
          }}</el-form-item>
          <el-form-item label="付款人：">{{ itemData.payer }}</el-form-item>
          <el-form-item label="付款时间：">{{ itemData.payTime }}</el-form-item>
          <el-form-item label="付款凭证："></el-form-item>
          <div v-if="itemData.paymentVoucher">
            <img
              :src="$utils.fileUrl(itemData.paymentVoucher)"
              v-if="
                $utils.fileType(itemData.paymentVoucher) === 'png' ||
                $utils.fileType(itemData.paymentVoucher) === 'jpg'
              "
              alt=""
            />
            <template v-else>
              <embed
                :src="$utils.fileUrl(itemData.paymentVoucher)"
                type="application/pdf"
              />
            </template>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" size="mini" @click="payment_dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 提交报告 -->
    <el-dialog
      v-model="report_dialog"
      width="550px"
      title="是否提交报告并完结订单?"
      destroy-on-close
      @close="close"
    >
      <div class="report_dialog-body">
        <el-form
          size="mini"
          :model="form"
          :rules="rules"
          ref="form"
          label-position="top"
        >
          <el-form-item label="上传文件：" prop="reportUrl">
            <li class="upload-file">
              <el-button type="primary" @click="selectFile">{{
                form.reportUrl ? "重新选择" : "选择报告"
              }}</el-button
              ><span
                >只支持上传.jpg、.png、.pdf、.zip、.rar格式文件,文件大小不超过50M</span
              >
            </li>
            <input type="file" id="upload" @change="upload" />
            <li>{{ form.file }}</li>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" size="mini" @click="addReport"
            >确认</el-button
          >
          <el-button type="danger" size="mini" @click="report_dialog = false"
            >取消</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      companyName: "",
      time: "",
      reportType: "",
      scaleType: "",
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "未超时",
        },
        {
          value: 1,
          label: "超时",
        },
      ],
      type_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "履约报告",
        },
        {
          value: 2,
          label: "信贷报告",
        },
        {
          value: 3,
          label: "综合报告",
        },
      ],
      company_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "小微企业",
        },
        {
          value: 2,
          label: "中型企业",
        },
        {
          value: 3,
          label: "大型企业",
        },
      ],
      archives_dialog: false,
      payment_dialog: false,
      report_dialog: false,
      itemData: {},
      form: {
        reportUrl: "",
        file: "",
      },
      rules: {
        reportUrl: [
          { required: true, message: "请上传报告", trigger: "change" },
        ],
      },
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    search() {
      this.getData();
    },
    async getData(page = 1) {
      if (this.companyName.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          time: this.time,
          reportType: this.reportType,
          scaleType: this.scaleType,
          name: this.companyName,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.xinfuReport.processing.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    formatType(row, column) {
      switch (row.type) {
        case 1:
          return "履约报告";
        case 2:
          return "信贷报告";
        case 3:
          return "综合报告";
      }
    },
    formaScale(row, column) {
      switch (row.scaleType) {
        case 1:
          return "小微企业";
        case 2:
          return "中型企业";
        case 3:
          return "大型企业";
      }
    },
    payment(data) {
      this.itemData = data;
      this.payment_dialog = true;
    },
    archives(data) {
      this.$store.dispatch("setCompanyId", data.companyId);
      this.archives_dialog = true;
    },
    selectFile() {
      const dom = document.getElementById("upload");
      dom.click();
    },
    upload(e) {
      e = e.target || e.srcElement;
      const files = e.files[0];
      if (e.value == "") {
        return;
      }

      if (files.name.length > 50) {
        this.$message.warning(`文件名称过长，不能超过50个字符`);
        return;
      }

      let args = files.name.split(".");
      let nameType = args[args.length - 1];
      const fileType = ["jpg", "png", "pdf", "zip", "rar"];

      if (fileType.indexOf(nameType) < 0) {
        this.$message.warning(`不支持上传${nameType}格式的文件`);
        return;
      }

      const size = files.size / 1024 / 1024;

      if (size > 50) {
        this.$message.warning(`文件大小不能超过50M`);
        return;
      }

      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        this.$api
          .uploadFile("1", files)
          .then((res) => {
            this.$message.success("上传成功");
            this.form.reportUrl = res;
            this.form.file = files.name;
            e.value = "";
            this.$loading.done();
            this.loading = false;
            this.$refs["form"].validateField("reportUrl");
          })
          .catch((err) => {
            e.value = "";
            this.$loading.done();
            this.loading = false;
          });
      }
    },
    addReport() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submitAddReport();
          this.refuse_dialog = false;
        } else {
          return false;
        }
      });
    },
    // 上传报告
    async submitAddReport() {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            id: this.itemData.id,
            reportUrl: this.form.reportUrl,
            type: 1,
            reportName: this.$utils.fileName(this.form.file),
          };
          const res = await this.$api.xinfuReport.processing.addReport(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.$message.success("提交成功！");
            this.report_dialog = false;
            this.getData(this.data.current);
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    close() {
      this.form.reportUrl = "";
      this.form.file = "";
    },
  },
  watch: {
    companyName: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;
  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .el-select {
    width: 120px;
  }
}

.end {
  color: $--color-danger;
}

.overdue {
  li {
    color: $--color-danger;
  }
}
.rational {
  li {
    color: $--color-success;
  }
}

.report {
  cursor: pointer;
}

.preview-dialog {
  img {
    width: 100%;
  }
}

.payment_dialog-body {
  embed {
    width: 100%;
    height: 800px;
  }
  img {
    width: 100%;
  }
}

.report_dialog-body {
  height: 98px;
  input[type="file"] {
    display: none;
  }

  .upload-file {
    line-height: 28px;

    & > span {
      margin-left: 20px;
      font-size: 0.75rem;
    }
  }
}
</style>